var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up",
    clipPath: "url(#clip0_1495_465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 6C1 6 2.12255 5.07469 2.71429 4.28571C3.30602 3.49674 4 2 4 2C4 2 4.69398 3.49674 5.28571 4.28571C5.87745 5.07469 7 6 7 6",
    stroke: "#4B4639",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 11L4 3",
    stroke: "#4B4639",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1495_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    fill: "white",
    transform: "matrix(0 1 -1 0 8 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.fe8fd3c12794c2c5a2b0ef1f21d81472.svg";
export { ForwardRef as ReactComponent };